<template>
  <div class="layout-topbar">
    <div class="layout-topbar-title">
      <button class="layout-menu-button p-link" @click="onMenuToggle">
        <span class="pi pi-bars"></span>
      </button>
      <span>
        <h2>{{ pageTitle }}</h2>
      </span>
    </div>
    <span class="layout-topbar-search-input">
      <component
        :is="searchBar"
        @search="$emitter.emit('topbar-search', $event)"
      ></component>
    </span>
    <span class="layout-topbar-username">
      <h3>{{ userName }}</h3>
      <div class="layout-topbar-icons">
        <Button
          @click="onProfileMenuToggle($event)"
          icon="pi pi-user"
          class="p-button-rounded p-button-info p-button-text"
        />
        <Menu ref="profileMenu" :model="items" :popup="true" appendTo="body" />
      </div>
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    pageTitle: String,
    userName: String,
    searchBar: Object,
  },
  computed: {
    ...mapGetters('app', ['appVersion']),
    items() {
      return [
        {
          label: 'Configurações do Usuário',
          icon: 'pi pi-user-edit',
          command: () => this.$emit('edit-profile'),
        },
        {
          label: 'Termo de uso e privacidade',
          icon: 'pi pi-bars',
          command: () => this.$router.push({ name: 'terms-and-privacy' }),
        },
        {
          label: 'Processos em segundo plano',
          icon: 'pi pi-cloud-upload',
          command: () => this.$router.push({ name: 'job.list' }),
        },
        {
          label: 'Logout',
          icon: 'pi pi-power-off',
          command: () => this.$emit('logout'),
        },
        {
          label: `Versão Atual: ${this.appVersion || '-'}`,
          icon: 'pi pi-tag',
        },
      ];
    },
  },
  methods: {
    onMenuToggle(event) {
      this.$emit('menu-toggle', event);
    },
    onProfileMenuToggle(event) {
      this.$refs.profileMenu.toggle(event);
    },
  },
};
</script>

<style scoped>
.p-menu {
  width: 230px;
}
</style>